module.exports = __webpack_public_path__ + "img/hk.6befc07b.svg";